import React from 'react';
import styled from 'styled-components';

import { ReviewStartIcon } from '@/public/icons';
import { devices } from '@/styles/breakpoints';

const arr = [1, 2, 3, 4, 5];

export const Reviews = () => {
  const aggregateRating = `{
    "@context": "http://schema.org",
     "@type": "CreativeWorkSeries",
     "name": "Our reviews",
     "aggregateRating": {
       "@type": "AggregateRating",
       "ratingValue": "4.9",
       "reviewCount": 17
       }
   }
   `;
  return (
    <Wrapper>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: aggregateRating,
        }}
      />
      <StarsWrapper>
        {arr.map((item) => (
          <span key={item}>
            <ReviewStartIcon />
          </span>
        ))}
      </StarsWrapper>
      <Text>
        <span>4.95</span> from <span>5</span> based on <span>17</span> reviews
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 16px 0;
  display: flex;
  align-items: center;

  gap: 10px;
`;

const StarsWrapper = styled.div``;

const Text = styled.p`
  color: #4d4d4d;
  font-family: var(--font-roboto);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  @media only screen and ${devices.desktop} {
  }
`;
